import React from "react";

const GradeTable = ({ thead = [], tbody, title }) => {
  //   const [obtainedMarks, setObtaiedMarks] = useState(0);
  const markObtain = tbody.reduce((sum, subject) => sum + subject.marks, 0);

  const getGradePoint = (marks) => {
    if (marks >= 90) return 10;
    if (marks >= 80) return 9;
    if (marks >= 70) return 8;
    if (marks >= 60) return 7;
    if (marks >= 50) return 6;
    if (marks >= 40) return 5;
    return 0;
  };

  const totalGradePoints = tbody.reduce(
    (sum, subject) => sum + getGradePoint(subject.marks),
    0
  );

  const cgpa = totalGradePoints / tbody.length;
  const percentage = cgpa * 9.5;

  return (
    <table className="studentGradeTable">
      <thead>
        <tr>
          {thead.length > 0 &&
            thead.map((_heading) => {
              return <th>{_heading}</th>;
            })}
        </tr>
        <tr>
          <th colSpan={5}>{title}</th>
        </tr>
      </thead>

      <tbody>
        {tbody.length > 0 &&
          tbody.map((_bodyData) => {
            return (
              <tr>
                <td>{_bodyData.name}</td>
                <td>{_bodyData.code}</td>
                <td>{_bodyData.type}</td>
                <td>{_bodyData.marks}</td>
                <td>{_bodyData.grade}</td>
              </tr>
            );
          })}
        <tr>
          <td colSpan={5}>
            <div className="flex-row align-center justify-between ">
              <span className="t-17 poppins bold">ACHIVED: {markObtain}</span>
              <span className="t-17 poppins bold">STATUS: PASS</span>
              <span className="t-17 poppins bold">
                TOTAL : {tbody.length * 100}
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <td colSpan={5}>
            <div className="flex-row align-center justify-between ">
              <span className="t-17 poppins bold">CGPA: {cgpa}</span>
              <span className="t-17 poppins bold">RANK: 01</span>
              <span className="t-17 poppins bold">
                PERCENTAGE: {percentage} %
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <td colSpan={5} style={{ height: "3.5rem" }}></td>
        </tr>
      </tbody>
    </table>
  );
};

export default GradeTable;
